<template>
<v-card flat max-width="950px" class="mx-auto transparent">
   
   <Message />

    <v-card outlined max-width="950px" class="mx-auto pa-6 pa-sm-10" style="border-top-left-radius:0; border-top-right-radius:0;">

        <v-row class="d-flex justify-center">
            <v-col cols="12" sm="7" md="9">
                <div class="headline font-weight-medium mt-2">
                    <div class="primary--text">Welcome to the 3 Steps Monthly Subscription program.</div>
                    <div class="title mt-2 accent--text">$12.99 USD Monthly</div>
                    <div class="caption font-weight-medium">- CANCEL ANYTIME -</div>
                </div>

                <div class="mt-4" style="line-height:1.4">
                   Learn at your own pace, and enjoy everything our 3 Steps Online World will be offering you.
                </div>

                <div class="mt-2 font-weight-medium">Our program includes:</div>
                <ul>
                    <li>Unlimited access to our 3 Steps Online world tools.</li>
                    <li>Unlimited streaming of our 3 Steps Online video courses.</li>
                    <li>Access to our weekly class Library.</li>
                    <li>And much more.</li>
                </ul>

                <div class="mt-2">This program will allow your teen to experience the 3 Steps to College key concepts, skills development, 
                    and online tools for college, career, and beyond.
                </div>

                <form autocomplete="off">
                    <div class="px-sm-8 mt-8">
                        <div class="mb-4 body-2 font-weight-medium mt-6">Parent´s info:</div>
                        <v-text-field
                            class="mt-n2"
                            v-model="model.parentName"
                            label="Parent´s name"
                            outlined dense
                            hint="Name card holder." persistent-hint
                            autocomplete="off"
                            @keydown.enter="validate">
                            <template v-slot:prepend-inner>
                                <v-icon color="info" class="mt-2 mr-1" size="12px">fa-user</v-icon>
                            </template>
                        </v-text-field>
                        <v-text-field
                            class="mt-1"
                            v-model="model.parentEmail"
                            label="Parent´s email"
                            outlined dense
                            autocomplete="off"
                            @keydown.enter="validate"
                            type="email">
                            <template v-slot:prepend-inner>
                                <v-icon color="info" class="mt-2 mr-1" size="12px">fa-envelope</v-icon>
                            </template>
                        </v-text-field>

                        <div class="mb-4 body-2 font-weight-medium">Student´s info:</div>
                        <v-text-field
                            class="mt-n2"
                            v-model="model.name"
                            label="Student´s name"
                            autocomplete="off"
                            outlined dense
                            @keydown.enter="validate">
                            <template v-slot:prepend-inner>
                                <v-icon color="info" class="mt-2 mr-1" size="12px">fa-user</v-icon>
                            </template>
                        </v-text-field>
                        <v-text-field
                            class="mt-n2"
                            v-model="model.email"
                            label="Student´s email"
                            outlined dense
                            autocomplete="off"
                            @keydown.enter="validate"
                            hint="This is going to be the user account to access the platform." persistent-hint
                            type="email">
                            <template v-slot:prepend-inner>
                                <v-icon color="info" class="mt-2 mr-1" size="12px">fa-envelope</v-icon>
                            </template>
                        </v-text-field>
                        <v-select
                            class="mt-2"
                            v-model="model.age"
                            :items="['15', '16', '17', '18']"
                            append-icon="fa-angle-down accent--text"
                            outlined dense
                            autocomplete="off"
                            label="Student´s age">
                        </v-select>
                        <v-autocomplete
                            class="mt-n2"
                            v-model="model.country"
                            :items="countries"
                            append-icon="fa-angle-down accent--text"
                            outlined dense
                            autocomplete="off"
                            label="Country">
                        </v-autocomplete>
                        
                        <v-btn block class="accent mt-n1" large depressed @click="validate" :disabled="sending">
                            <span v-if="!sending">Enroll now</span>
                            <span v-else>Wait a moment...</span>
                        </v-btn>
                    </div>
                 </form>
            </v-col>
        </v-row>
        
    </v-card>
</v-card>
</template>

<script>
import Subscription from  '@/firebase/subscription'
import Countries from '@/services/countries'
import Message from '@/components/cart/Message'

export default {
  	data: () => ({
        sending: false,
        //stripe: Stripe('pk_test_KYTOODeedtqcJ29G1YWKqWCm00wnDN3hYF'),
        stripe: Stripe('pk_live_E4wZNtU8q9fgnrlSZGHMF11300ossTG5a9'),
        model: {
            name: '',
            email: '',
            age: '',
            country: '',
			parentName: '',
            parentEmail: ''
        },
        countries: Countries.items,
    }),
    components: {
        Message
    },
    mounted() {
		this.$gtm.trackView('Subscription', '/subscription');
	},
  	methods: {
        validate() {
            if (this.validateIsEmpty(this.model.parentName)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Parent´s name missing'});
                return;
            }
            if (!this.validateIsEmail(this.model.parentEmail)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Parent´s email not valid'});
                return;
            }
            if (this.validateIsEmpty(this.model.name)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Student´s name missing'});
                return;
            }
            if (this.validateIsEmpty(this.model.email)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Student´s email missing'});
                return;
            }
            if (!this.validateIsEmail(this.model.email)) {
                this.$store.dispatch('setSnack', {kind:'error', text:'Student´s email not valid'});
                return;
            }
            if (this.model.age == '') {
                this.$store.dispatch('setSnack', {kind:'error', text:'Student´s Age missing'});
                return;
            }
            if (this.model.country == '') {
                this.$store.dispatch('setSnack', {kind:'error', text:'Country missing'});
                return;
            }
            
            this.goCreateCheckout();
        },
		goCreateCheckout() {
            this.model.parentEmail = this.model.parentEmail.toLowerCase();
            this.model.email = this.model.email.toLowerCase();

            this.sending = true;

			Subscription.createCustomer(this.model)
				.then(response => {
					if (response.status === true) {
						this.$router.push('/checkout/'+response.content.id)
					} else {
						this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
					}
				});
		}
  	}
}
</script>